import createMuiTheme from "@material-ui/core/styles/createMuiTheme";

export const menuItemsTheme = createMuiTheme({
    overrides: {
        MuiMenuItem: {
            root: {
                paddingTop: "0.5rem",
                paddingBottom: "0.5rem",
                fontWeight: 600,
                fontSize: "1.2rem",
                "&:nth-last-child(2)": {
                    color: "#000000",
                    backgroundColor: "#E0EEE0",
                    borderTop: "solid",
                    paddingTop: "0.5rem"
                },
                "&:last-child": {
                    color: "#000000",
                    backgroundColor: "#90EE90",
                    borderTop: "solid",
                    paddingTop: "0.5rem"
                }
            }
        }
    }
});